module.exports = __webpack_public_path__ + "img/upload-attachment.05a5849b.svg";